import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "Diensten", path: "/diensten" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-slate-900 text-white sticky top-0 z-50 shadow-lg border-b border-slate-800">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group h-full py-2">
            <div className="bg-white/10 p-1.5 rounded-lg group-hover:bg-white/20 transition-colors shrink-0 h-full flex items-center">
              <img 
                src="https://i.imgur.com/mqc6Kb5.png" 
                alt="M Pomp Multiservice Logo" 
                className="h-full w-auto object-contain max-h-16"
              />
            </div>
            <div className="flex flex-col justify-center">
              <span className="text-lg md:text-xl font-bold tracking-tight text-white leading-tight">
                M Pomp <span className="text-amber-500">Multiservice</span>
              </span>
              <span className="text-[10px] md:text-xs text-slate-400 uppercase tracking-widest">
                Installatietechniek
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-amber-500 ${
                  isActive(link.path) ? "text-amber-500" : "text-slate-300"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* Mobile Actions (Menu) */}
          <div className="md:hidden flex items-center gap-4">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-slate-300 hover:text-white focus:outline-none p-2"
            >
              {isOpen ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-slate-800 border-t border-slate-700 animate-in slide-in-from-top-5">
          <div className="px-4 pt-6 pb-6 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-3 py-3 rounded-md text-base font-medium ${
                  isActive(link.path)
                    ? "bg-slate-900 text-amber-500"
                    : "text-slate-300 hover:bg-slate-700 hover:text-white"
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;